export default {
  namespaced: true,

  state: {
    transformers: {},
    loaded: false
  },

  getters: {
    getTransformer: (state) => (target) => {
      return state.transformers[target] || null
    },
    isLoaded: (state) => state.loaded,
    allTransformers: (state) => Object.values(state.transformers)
  },

  mutations: {
    SET_TRANSFORMERS(state, transformers) {
      state.transformers = transformers.reduce((acc, t) => {
        acc[t.target] = t
        return acc
      }, {})
      state.loaded = true
    },

    CLEAR_TRANSFORMERS(state) {
      state.transformers = {}
      state.loaded = false
    }
  },

  actions: {
    storeTransformers({ commit }, data) {
      if (Array.isArray(data)) {
        commit('SET_TRANSFORMERS', data)
      }
    },

    clearTransformers({ commit }) {
      commit('CLEAR_TRANSFORMERS')
    }
  }
}
